(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["ForceAtlas2Layout"] = factory();
	else
		root["ForceAtlas2Layout"] = factory();
})(this, function() {
return 